<template>
    <div class="popsale-ad" v-show="this.ad" v-on:click="toggle">
        <div class="popsale-ad__content">
            <a v-if="ad" :href="this.ad.action_link">
                <img v-if="ad" :src="this.ad.advertise_photos[0].url" alt="advertise"/>
            </a>
        </div>

        <div v-if="isClosable" class="popsale-ad-dismiss" v-on:click="close">
            <button class="mdc-icon-button material-icons" data-mdc-auto-init="MDCRipple">close</button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        'requestLink': {
            type: String | Location,
            required: true,
        },
        'dismissTime': {
            default: 0,
        }
    },
    computed: {
        isShow: function () {
            return window.Cookies.get('ad-show');
        },
    },
    data: function() {
        return {
            ad: null,
            isClosable: false,
        }
    },
    methods: {
        toggle: function () {
            if ($('.popsale-ad').is(':visible')) {
                if (!this.isClosable) {
                    return
                }

                $('.popsale-ad').hide()
            } else {
                $('.popsale-ad').show();
            }
        },
        close : function (event) {
            event.stopPropagation();
            this.ad = null;
        }
    },
    mounted() {
        window.mdc.autoInit();

        setTimeout(function () {
            this.isClosable = true;
        }.bind(this), this.dismissTime * 1000);

        if (this.isShow) return;

        $.ajax({
            url: this.requestLink,
            method: 'GET',
            dataType: 'json',
            success: function (response) {
                if (response.data.length) {
                    let date = new Date();
                    date.setTime(date.getTime() + (30 * 60 * 1000));
                    Cookies.set('ad-show', true, { expires: date });
                    this.ad = response.data[Math.floor(Math.random() * response.data.length)];
                }
            }.bind(this)
        })
    }
}
</script>

<style lang="scss">
    .popsale-ad {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(121, 206, 197, 0.54);
        z-index: 99999;

        .popsale-ad__content {
            text-align: center;
            display: block;

            img {
                position: absolute;
                max-width: 70%;
                max-height: 70vh;
                height: auto;
                top: 50%;
                transform: translate(-50%,-50%);
                -ms-transform: translate(-50%,-50%);
                cursor: pointer;
            }
        }

        .popsale-ad-dismiss .material-icons {
            position: absolute;
            top: 20px;
            right: 20px;
            color: white;
        }
    }
</style>